<div *ngIf="show$ | async" class="navigation-menu">
    <div class="navigation-menu__container">
        <div class="navigation-menu__item"
             [class.active]="isTenants"
             (click)="toTenants()">
            <app-icons class="navigation-menu__item-icon"
                       [name]="'graph'"
                       [color]="isTenants && !isFarm ? '#FFFFFF' : '#000000'" [width]="24" [height]="24"></app-icons>
            <span class="navigation-menu__item-text">Trades Manager</span>
        </div>
        <div *ngIf="isFairLaunchAvailable" class="navigation-menu__item"
             [class.active]="isFairLaunch"
             (click)="toFairLaunch()">
            <app-icons class="navigation-menu__item-icon"
                       [name]="'arbitrage'"
                       [color]="isFairLaunch ? '#FFFFFF' : '#000000'" [width]="24" [height]="24"></app-icons>
            <span class="navigation-menu__item-text">Fair Launch</span>
        </div>
        <div *ngIf="isFarmsAvailable" class="navigation-menu__item"
             [class.active]="isFarm"
             (click)="toFarms()">
            <app-icons class="navigation-menu__item-icon"
                       [name]="'farms'"
                       [color]="isFarm ? '#FFFFFF' : '#000000'" [width]="36" [height]="36"></app-icons>
            <span class="navigation-menu__item-text">Farms</span>
        </div>
         <div *ngIf="isStatisticsAvailable" class="navigation-menu__item"
             [class.active]="isStatistics"
             (click)="toStatistics()">
            <app-icons class="navigation-menu__item-icon"
                       name="chart-column"
                       [color]="isStatistics ? '#FFFFFF' : '#000000'" [width]="24" [height]="24"></app-icons>
            <span class="navigation-menu__item-text">Statistic</span>
        </div>
    </div>
    <div class="navigation-menu__item" (click)="logout()">
        <app-icons class="navigation-menu__item-icon"
                   [name]="'logout'"
                   [color]="'#361208'" [width]="24" [height]="24"></app-icons>
        <span class="navigation-menu__item-text">Logout</span>
    </div>
</div>
